import { ApplicationRef, ComponentFactoryResolver, Injectable, Injector } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomSnackbarComponent } from '../_component/sharedComponents/custom-snackbar/custom-snackbar.component';

@Injectable({
  providedIn: 'root'
})
export class CustomControlsService {

  constructor(
    private resolver: ComponentFactoryResolver,
    private injector: Injector,
    private appRef: ApplicationRef
  ) {}

  showNotification(
    type: 'success' | 'error' | 'warning' | 'info',
    message: string,
    title: string = '',
    duration: number = 3000
  ) {
    const factory = this.resolver.resolveComponentFactory(CustomSnackbarComponent);
    const componentRef = factory.create(this.injector);

    componentRef.instance.type = type;
    componentRef.instance.message = message;
    componentRef.instance.title = title;
    componentRef.instance.duration = duration;

    this.appRef.attachView(componentRef.hostView);

    const domElem = (componentRef.hostView as any).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);

    setTimeout(() => {
      this.appRef.detachView(componentRef.hostView);
      componentRef.destroy();
    }, duration + 400);
  }
}